// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { create } from 'zustand';

/**
 * Open state for the beta explainer. The modal is mounted once in RootLayoutNav, but the badges
 * that open it live in three separate trees (the shared header, the shell overlay used by the
 * header-less screens, and the tour editor's breadcrumb row), so the flag lives outside all of them.
 */
type BetaInfoState = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const useBetaInfoState = create<BetaInfoState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));
